module.exports = __webpack_public_path__ + "static/media/osann.2436fd45.mp3";